<div class="form-toggle" [class.form-toggle--disabled]="isDisabled()">
  @if (label()) {
    <span class="form-toggle__label" [id]="labelId">{{ label() }}</span>
  }

  <button
    type="button"
    class="form-toggle__switch"
    role="switch"
    [id]="switchId"
    [class.form-toggle__switch--on]="isChecked()"
    [attr.aria-checked]="isChecked()"
    [attr.aria-labelledby]="label() ? labelId : null"
    [attr.aria-label]="!label() ? 'Toggle' : null"
    [attr.data-testid]="testId()"
    [disabled]="isDisabled()"
    (click)="onSwitchClick()"
  >
    <span class="form-toggle__track" aria-hidden="true">
      <span class="form-toggle__thumb"></span>
    </span>
  </button>
</div>
